import {FunctionComponent, useEffect, useState} from "react";
import {Navigate} from "react-router-dom";
import {getAuth, onAuthStateChanged, User} from "firebase/auth";
import {Auth} from "../../firebase/firebase";
import AdminSelectManager from "./pages/AdminSelectManager";
import LoginUser from "../development/LoginUser";

const AdminLand: FunctionComponent = () => {
  const [user, setUser] = useState<User | null>();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    return onAuthStateChanged(Auth, (u) => {
      setUser(u);
      setReady(true);
    });
  }, []);

  if (!ready || user === undefined) return null;

  if (user === null) {
    return <LoginUser/>;
  }

  return <AdminSelectManager/>;
};

export default AdminLand;
